// Events originating from the Webshop sent to Cassie through the Websocket
export var CassieWSMethods;
(function (CassieWSMethods) {
    CassieWSMethods["Subscribe"] = "SubscribeThirdParty";
})(CassieWSMethods || (CassieWSMethods = {}));
// Events originating from Cassie received through the Websocket
export var CassieWSEvents;
(function (CassieWSEvents) {
})(CassieWSEvents || (CassieWSEvents = {}));
export var IntegrationChannel;
(function (IntegrationChannel) {
    IntegrationChannel["Webshop"] = "webshop";
})(IntegrationChannel || (IntegrationChannel = {}));
// Outgoing message types
export var ThirdPartyWSMethod;
(function (ThirdPartyWSMethod) {
    ThirdPartyWSMethod["Subscribe"] = "SubscribeThirdParty";
    ThirdPartyWSMethod["Unsubscribe"] = "UnsubscribeThirdParty";
    ThirdPartyWSMethod["NotifyProductVisited"] = "NotifyProductVisited";
})(ThirdPartyWSMethod || (ThirdPartyWSMethod = {}));
export var CoolblueSubsidiary;
(function (CoolblueSubsidiary) {
    CoolblueSubsidiary[CoolblueSubsidiary["Netherlands"] = 1] = "Netherlands";
    CoolblueSubsidiary[CoolblueSubsidiary["Belgium"] = 3] = "Belgium";
    CoolblueSubsidiary[CoolblueSubsidiary["Germany"] = 5] = "Germany";
})(CoolblueSubsidiary || (CoolblueSubsidiary = {}));
//# sourceMappingURL=types.js.map